// BottomFooter.jsx
// The bottom bar is now built directly into FooterOne.jsx.
// This file is kept as a no-op stub so existing imports don't break.
import React from "react";
const BottomFooter = () => null;
export default BottomFooter;